// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
 * Bind Google Authenticator page — scoped styles (prefix: bga-)
 * ========================================================================== */

.bga-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 40px 80px;
  color: #eaeaea;
  background: #171a20;
  min-height: 100vh;
  box-sizing: border-box;
}

body.light_theme .bga-page {
  color: #1a1a1a;
  background: #fff;
}

.bga-page__crumbs {
  font-size: 13px;
  color: #707a8a;
  margin-bottom: 24px;
}

.bga-page__crumbList {
  display: flex;
  gap: 6px;
  list-style: none;
  padding: 0;
  margin: 0;
  align-items: center;
}

.bga-page__crumbLink {
  background: none;
  border: 0;
  color: #707a8a;
  cursor: pointer;
  padding: 0;
  font-size: 13px;
}

.bga-page__crumbLink:hover {
  color: #dcdcdc;
}

body.light_theme .bga-page__crumbLink:hover {
  color: #1a1a1a;
}

.bga-page__crumbSep {
  color: #b7bdc6;
}

.bga-page__crumbItem--active {
  color: #e9e9e9;
  font-weight: 500;
}

body.light_theme .bga-page__crumbItem--active {
  color: #1a1a1a;
}

.bga-page__title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 40px;
  color: #e8e8e8;
}

body.light_theme .bga-page__title {
  color: #1a1a1a;
}

.bga-page__grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 48px;
  align-items: start;
}

@media (max-width: 992px) {
  .bga-page__grid {
    grid-template-columns: 1fr;
  }
}

/* ---------- Steps column (left) ---------- */

.bga-step {
  display: grid;
  grid-template-columns: 32px 1fr;
  gap: 16px;
  margin-bottom: 36px;
}

.bga-step__num {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #f5f5f5;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  margin-top: 2px;
}

.bga-step__heading {
  font-size: 15px;
  font-weight: 600;
  color: #e9e9e9;
  margin: 0 0 6px;
}

body.light_theme .bga-step__heading {
  color: #1a1a1a;
}

.bga-step__note {
  font-size: 12px;
  color: #b5b5b5;
  margin: 0 0 16px;
}

body.light_theme .bga-step__note {
  color: #707a8a;
}

/* ---------- Step 1: App download cards ---------- */

.bga-apps {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.bga-apps__card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-width: 180px;
  padding: 14px 16px;
  background: #ffffff0d;
  border: 1px solid #eaecef0f;
  border-radius: 10px;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  text-decoration: none;
  color: inherit;
}

body.light_theme .bga-apps__card {
  background: #fff;
  border: 1px solid #eaecef;
}

.bga-apps__card:hover {
  border-color: #d4af37;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}

.bga-apps__card-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.bga-apps__logo {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 22px;
}

body.light_theme .bga-apps__logo {
  color: #1a1a1a;
}

.bga-apps__title {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  line-height: 1.2;
}

body.light_theme .bga-apps__title {
  color: #1a1a1a;
}

.bga-apps__sub {
  font-size: 11px;
  color: #dddddd;
  line-height: 1.2;
}

body.light_theme .bga-apps__sub {
  color: #707a8a;
}

.bga-apps__qr {
  width: 26px;
  height: 26px;
  color: #dddddd;
  display: flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .bga-apps__qr {
  color: #1a1a1a;
}

/* ---------- Step 2: QR + key card ---------- */

.bga-qr {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 14px;
  background: #ffffff0d;
  border: 1px solid #eaecef0f;
  border-radius: 10px;
  max-width: 520px;
}

body.light_theme .bga-qr {
  border: 1px solid #eaecef;
  background: #fff;
}

.bga-qr__img {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
}

.bga-qr__img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.bga-qr__key {
  flex: 1 1;
  font-size: 13px;
  font-weight: 600;
  color: #e2e2e2;
  font-family: "SFMono-Regular", Consolas, monospace;
  word-break: break-all;
}

body.light_theme .bga-qr__key {
  color: #1a1a1a;
}

.bga-qr__copy {
  background: none;
  border: 0;
  color: #707a8a;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bga-qr__copy:hover {
  background: #f5f5f5;
  color: #1a1a1a;
}

/* ---------- Step 3: Inputs ---------- */

.bga-field {
  margin-bottom: 20px;
  max-width: 520px;
}

.bga-field__label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #e8e8e8;
  margin-bottom: 8px;
}

body.light_theme .bga-field__label {
  color: #1a1a1a;
}

.bga-field__control {
  position: relative;
  display: flex;
  align-items: stretch;
  border: 1px solid #eaecef12;
  border-radius: 8px;
  background: #ffffff10;
  overflow: hidden;
  transition: border-color 0.15s ease;
}

body.light_theme .bga-field__control {
  border: 1px solid #eaecef;
  background: #fff;
}

.bga-field__control:focus-within {
  border-color: #737373;
}

.bga-field__input {
  flex: 1 1;
  border: 0;
  outline: none;
  background: transparent;
  padding: 12px 14px;
  font-size: 14px;
  color: #d3d3d3;
  min-width: 0;
}

body.light_theme .bga-field__input {
  color: #1a1a1a;
}

.bga-field__input::placeholder {
  color: #b7bdc6;
}

.bga-field__sendBtn {
  border: 0;
  background: transparent;
  color: #242424;
  font-weight: 600;
  font-size: 13px;
  padding: 0 16px;
  cursor: pointer;
}

.bga-field__sendBtn:disabled {
  color: #b7bdc6;
  cursor: not-allowed;
}

.bga-field__sendBtn:hover:not(:disabled) {
  color: #1e5de3;
}

.bga-field__hint {
  font-size: 12px;
  color: #707a8a;
  margin: 8px 0 0;
}

/* ---------- Actions ---------- */

.bga-page__confirm {
  margin-top: 24px;
  width: 100%;
  max-width: 520px;
  padding: 14px 20px;
  background: #eaecef;
  color: #b7bdc6;
  font-size: 15px;
  font-weight: 600;
  border: 0;
  border-radius: 999px;
  cursor: not-allowed;
  transition: background 0.15s ease, color 0.15s ease;
}

.bga-page__confirm.is-ready {
  background: #303236;
  color: #ffffff;
  cursor: pointer;
}

/* .bga-page__confirm.is-ready:hover {
  background: #c19b2a;
} */

.bga-page__unable {
  display: inline-block;
  margin-top: 18px;
  background: none;
  border: 0;
  color: #2f71ff;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
}

.bga-page__unable:hover {
  color: #1e5de3;
}

/* ---------- Notes column (right) ---------- */

.bga-notes {
  font-size: 13px;
  color: #dcdcdc;
  line-height: 1.6;
}

body.light_theme .bga-notes {
  color: #1a1a1a;
}

.bga-notes__heading {
  font-size: 15px;
  font-weight: 700;
  margin: 0 0 14px;
}

.bga-notes__item {
  margin: 0 0 16px;
  color: #e6e6e6;
}

body.light_theme .bga-notes__item {
  color: #1a1a1a;
}

.bga-notes__link {
  color: #d1aa67;
  text-decoration: none;
}

.bga-notes__link:hover {
  text-decoration: underline;
}

/* ---------- Dark theme compatibility ---------- */

body.theme-dark .bga-page,
html[data-theme="dark"] .bga-page {
  background: #181a20;
  color: #e6e8ec;
}

body.theme-dark .bga-page__title,
body.theme-dark .bga-step__heading,
body.theme-dark .bga-qr__key,
body.theme-dark .bga-field__label,
body.theme-dark .bga-field__input,
body.theme-dark .bga-apps__title,
body.theme-dark .bga-notes__heading,
body.theme-dark .bga-notes__item,
body.theme-dark .bga-page__crumbItem--active {
  color: #e6e8ec;
}

body.theme-dark .bga-apps__card,
body.theme-dark .bga-qr,
body.theme-dark .bga-field__control {
  background: #151a23;
  border-color: #242a35;
}

body.theme-dark .bga-step__num {
  background: #1f2733;
  color: #e6e8ec;
}

body.theme-dark .bga-qr__img {
  background: #fff;
  border-color: #242a35;
}

body.theme-dark .bga-page__confirm {
  background: #242a35;
  color: #6d7482;
}


@media (max-width: 1024px) {


  .bga-page__title {
    font-size: 22px;
    margin: 0 0 20px;
  }


  .bga-page {
    padding: 32px 20px 30px;
  }

  .bga-qr__img {
    width: 70px;
    height: 70px;
  }

  .bga-page__grid {
    gap: 20px;
  }


}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TwofactorPage/bindGoogleAuthenticator.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,8CAA8C;;AAE9C;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,qDAAqD;;AAErD;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,0DAA0D;EAC1D,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,gDAAgD;;AAEhD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yCAAyC;;AAEzC;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,kCAAkC;;AAElC;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA,+CAA+C;;AAE/C;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mDAAmD;;AAEnD;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;;;;EASE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;;;EAGE;IACE,eAAe;IACf,gBAAgB;EAClB;;;EAGA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;;AAGF","sourcesContent":["/* ============================================================================\n * Bind Google Authenticator page — scoped styles (prefix: bga-)\n * ========================================================================== */\n\n.bga-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 32px 40px 80px;\n  color: #eaeaea;\n  background: #171a20;\n  min-height: 100vh;\n  box-sizing: border-box;\n}\n\nbody.light_theme .bga-page {\n  color: #1a1a1a;\n  background: #fff;\n}\n\n.bga-page__crumbs {\n  font-size: 13px;\n  color: #707a8a;\n  margin-bottom: 24px;\n}\n\n.bga-page__crumbList {\n  display: flex;\n  gap: 6px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  align-items: center;\n}\n\n.bga-page__crumbLink {\n  background: none;\n  border: 0;\n  color: #707a8a;\n  cursor: pointer;\n  padding: 0;\n  font-size: 13px;\n}\n\n.bga-page__crumbLink:hover {\n  color: #dcdcdc;\n}\n\nbody.light_theme .bga-page__crumbLink:hover {\n  color: #1a1a1a;\n}\n\n.bga-page__crumbSep {\n  color: #b7bdc6;\n}\n\n.bga-page__crumbItem--active {\n  color: #e9e9e9;\n  font-weight: 500;\n}\n\nbody.light_theme .bga-page__crumbItem--active {\n  color: #1a1a1a;\n}\n\n.bga-page__title {\n  font-size: 28px;\n  font-weight: 700;\n  margin: 0 0 40px;\n  color: #e8e8e8;\n}\n\nbody.light_theme .bga-page__title {\n  color: #1a1a1a;\n}\n\n.bga-page__grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 340px;\n  gap: 48px;\n  align-items: start;\n}\n\n@media (max-width: 992px) {\n  .bga-page__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ---------- Steps column (left) ---------- */\n\n.bga-step {\n  display: grid;\n  grid-template-columns: 32px 1fr;\n  gap: 16px;\n  margin-bottom: 36px;\n}\n\n.bga-step__num {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #f5f5f5;\n  color: #1a1a1a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  margin-top: 2px;\n}\n\n.bga-step__heading {\n  font-size: 15px;\n  font-weight: 600;\n  color: #e9e9e9;\n  margin: 0 0 6px;\n}\n\nbody.light_theme .bga-step__heading {\n  color: #1a1a1a;\n}\n\n.bga-step__note {\n  font-size: 12px;\n  color: #b5b5b5;\n  margin: 0 0 16px;\n}\n\nbody.light_theme .bga-step__note {\n  color: #707a8a;\n}\n\n/* ---------- Step 1: App download cards ---------- */\n\n.bga-apps {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.bga-apps__card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  min-width: 180px;\n  padding: 14px 16px;\n  background: #ffffff0d;\n  border: 1px solid #eaecef0f;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  text-decoration: none;\n  color: inherit;\n}\n\nbody.light_theme .bga-apps__card {\n  background: #fff;\n  border: 1px solid #eaecef;\n}\n\n.bga-apps__card:hover {\n  border-color: #d4af37;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);\n}\n\n.bga-apps__card-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.bga-apps__logo {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 22px;\n}\n\nbody.light_theme .bga-apps__logo {\n  color: #1a1a1a;\n}\n\n.bga-apps__title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  line-height: 1.2;\n}\n\nbody.light_theme .bga-apps__title {\n  color: #1a1a1a;\n}\n\n.bga-apps__sub {\n  font-size: 11px;\n  color: #dddddd;\n  line-height: 1.2;\n}\n\nbody.light_theme .bga-apps__sub {\n  color: #707a8a;\n}\n\n.bga-apps__qr {\n  width: 26px;\n  height: 26px;\n  color: #dddddd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .bga-apps__qr {\n  color: #1a1a1a;\n}\n\n/* ---------- Step 2: QR + key card ---------- */\n\n.bga-qr {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  padding: 14px;\n  background: #ffffff0d;\n  border: 1px solid #eaecef0f;\n  border-radius: 10px;\n  max-width: 520px;\n}\n\nbody.light_theme .bga-qr {\n  border: 1px solid #eaecef;\n  background: #fff;\n}\n\n.bga-qr__img {\n  width: 120px;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  border: 1px solid #f0f0f0;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.bga-qr__img img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.bga-qr__key {\n  flex: 1;\n  font-size: 13px;\n  font-weight: 600;\n  color: #e2e2e2;\n  font-family: \"SFMono-Regular\", Consolas, monospace;\n  word-break: break-all;\n}\n\nbody.light_theme .bga-qr__key {\n  color: #1a1a1a;\n}\n\n.bga-qr__copy {\n  background: none;\n  border: 0;\n  color: #707a8a;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.bga-qr__copy:hover {\n  background: #f5f5f5;\n  color: #1a1a1a;\n}\n\n/* ---------- Step 3: Inputs ---------- */\n\n.bga-field {\n  margin-bottom: 20px;\n  max-width: 520px;\n}\n\n.bga-field__label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #e8e8e8;\n  margin-bottom: 8px;\n}\n\nbody.light_theme .bga-field__label {\n  color: #1a1a1a;\n}\n\n.bga-field__control {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  border: 1px solid #eaecef12;\n  border-radius: 8px;\n  background: #ffffff10;\n  overflow: hidden;\n  transition: border-color 0.15s ease;\n}\n\nbody.light_theme .bga-field__control {\n  border: 1px solid #eaecef;\n  background: #fff;\n}\n\n.bga-field__control:focus-within {\n  border-color: #737373;\n}\n\n.bga-field__input {\n  flex: 1;\n  border: 0;\n  outline: none;\n  background: transparent;\n  padding: 12px 14px;\n  font-size: 14px;\n  color: #d3d3d3;\n  min-width: 0;\n}\n\nbody.light_theme .bga-field__input {\n  color: #1a1a1a;\n}\n\n.bga-field__input::placeholder {\n  color: #b7bdc6;\n}\n\n.bga-field__sendBtn {\n  border: 0;\n  background: transparent;\n  color: #242424;\n  font-weight: 600;\n  font-size: 13px;\n  padding: 0 16px;\n  cursor: pointer;\n}\n\n.bga-field__sendBtn:disabled {\n  color: #b7bdc6;\n  cursor: not-allowed;\n}\n\n.bga-field__sendBtn:hover:not(:disabled) {\n  color: #1e5de3;\n}\n\n.bga-field__hint {\n  font-size: 12px;\n  color: #707a8a;\n  margin: 8px 0 0;\n}\n\n/* ---------- Actions ---------- */\n\n.bga-page__confirm {\n  margin-top: 24px;\n  width: 100%;\n  max-width: 520px;\n  padding: 14px 20px;\n  background: #eaecef;\n  color: #b7bdc6;\n  font-size: 15px;\n  font-weight: 600;\n  border: 0;\n  border-radius: 999px;\n  cursor: not-allowed;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.bga-page__confirm.is-ready {\n  background: #303236;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n/* .bga-page__confirm.is-ready:hover {\n  background: #c19b2a;\n} */\n\n.bga-page__unable {\n  display: inline-block;\n  margin-top: 18px;\n  background: none;\n  border: 0;\n  color: #2f71ff;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0;\n}\n\n.bga-page__unable:hover {\n  color: #1e5de3;\n}\n\n/* ---------- Notes column (right) ---------- */\n\n.bga-notes {\n  font-size: 13px;\n  color: #dcdcdc;\n  line-height: 1.6;\n}\n\nbody.light_theme .bga-notes {\n  color: #1a1a1a;\n}\n\n.bga-notes__heading {\n  font-size: 15px;\n  font-weight: 700;\n  margin: 0 0 14px;\n}\n\n.bga-notes__item {\n  margin: 0 0 16px;\n  color: #e6e6e6;\n}\n\nbody.light_theme .bga-notes__item {\n  color: #1a1a1a;\n}\n\n.bga-notes__link {\n  color: #d1aa67;\n  text-decoration: none;\n}\n\n.bga-notes__link:hover {\n  text-decoration: underline;\n}\n\n/* ---------- Dark theme compatibility ---------- */\n\nbody.theme-dark .bga-page,\nhtml[data-theme=\"dark\"] .bga-page {\n  background: #181a20;\n  color: #e6e8ec;\n}\n\nbody.theme-dark .bga-page__title,\nbody.theme-dark .bga-step__heading,\nbody.theme-dark .bga-qr__key,\nbody.theme-dark .bga-field__label,\nbody.theme-dark .bga-field__input,\nbody.theme-dark .bga-apps__title,\nbody.theme-dark .bga-notes__heading,\nbody.theme-dark .bga-notes__item,\nbody.theme-dark .bga-page__crumbItem--active {\n  color: #e6e8ec;\n}\n\nbody.theme-dark .bga-apps__card,\nbody.theme-dark .bga-qr,\nbody.theme-dark .bga-field__control {\n  background: #151a23;\n  border-color: #242a35;\n}\n\nbody.theme-dark .bga-step__num {\n  background: #1f2733;\n  color: #e6e8ec;\n}\n\nbody.theme-dark .bga-qr__img {\n  background: #fff;\n  border-color: #242a35;\n}\n\nbody.theme-dark .bga-page__confirm {\n  background: #242a35;\n  color: #6d7482;\n}\n\n\n@media (max-width: 1024px) {\n\n\n  .bga-page__title {\n    font-size: 22px;\n    margin: 0 0 20px;\n  }\n\n\n  .bga-page {\n    padding: 32px 20px 30px;\n  }\n\n  .bga-qr__img {\n    width: 70px;\n    height: 70px;\n  }\n\n  .bga-page__grid {\n    gap: 20px;\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
